// src/components/admin/page-management/templates/HomeTemplate.js

const HomeTemplate = {
  title: "Home ",
  description: "A complete homepage with Hero Banner, Categories, Featured Products, and Blog sections",
  sections: [
    // Hero Banner Section
    {
      type: 'slideshowHeaderWave',
      content: {
        title: 'Paper Bag & Box <span>Custom Packaging</span>',
        subtitle: 'Elevate your brand with premium quality custom bags and boxes. Perfect for businesses of all sizes.',
        backgroundImage: '/images/s1.jpg',
        mobileBackgroundImage: '/images/s3.jpg',
        overlayColor: 'rgba(0,0,0,0.5)',
        primaryButtonText: 'Customize Products',
        primaryButtonLink: '/products',
        primaryButtonColor: '#d97706',
        secondaryButtonText: 'Call to Order',
        secondaryButtonLink: 'tel:+18333333101',
        secondaryButtonColor: '#16a34a',
        phoneNumber: '+18333333101',
        showPhoneIcon: true,
        showWaveSeparator: true,
        separatorColor: '#fbfbfb',
        particlesCount: 15,
        particlesColor: 'rgba(255, 255, 255, 0.2)',
        highlightColor: '#f59e0b',
        height: '100vh',
        minHeight: '600px',
        animationEnabled: true
      },
      settings: {
        fullWidth: true
      }
    },
    
    // Categories Section
    {
      type: 'productCatalogVertical',
      content: {
        title: 'Browse Categories',
        searchEnabled: true,
        searchPlaceholder: 'Search categories...',
        layoutType: 'vertical',
        sliderThreshold: 9,
        categoryImageShape: 'circle',
        categoryBorderColor: '#3b82f6',
        selectedCategoryBorderColor: '#3b82f6',
        loadMoreButtonText: 'Load More',
        loadMoreButtonColor: '#1e3a8a',
        loadIncrementDesktop: 6,
        loadIncrementMobile: 3,
        showLoadingAnimation: true,
        loadingAnimationUrl: '../images/loading.gif',
        apiPath: '/api/categories/basic',
        productApiPath: '/api/products/basic',
        gridColumns: {
          mobile: 1,
          tablet: 2,
          desktop: 3
        },
        verticalImageSize: 'medium',
        sliderImageSize: 'medium',
        fadeEffectEnabled: true
      },
      settings: {
        fullWidth: false
      }
    },
    
    // Static Content Section
    {
      type: 'staticContent',
      content: {
        title: 'Discover Our Unique Packaging Solutions',
        description: 'Experience creativity and innovation in every design. Our custom packaging solutions are crafted to elevate your brand\'s presence and make a lasting impression.',
        buttonText: 'Learn More',
        buttonLink: '/aboutUs',
        buttonColor: '#2563eb',
        buttonTextColor: '#ffffff',
        imageUrl: '/images/logo-static.png',
        imageAlt: 'Packaging',
        imageRadius: '50px',
        imageShadow: true,
        backgroundColor: '#3b82f6',
        backgroundGradient: true,
        gradientFrom: '#3b82f6',
        gradientTo: '#8b5cf6',
        textColor: '#ffffff',
        paddingTop: '2.5rem',
        paddingBottom: '2.5rem',
        paddingLeftDesktop: '40px',
        paddingRightDesktop: '0px',
        reverseOnMobile: false,
        marginTop: '0.5rem',
        marginBottom: '8rem',
        borderRadius: '0.5rem',
        animationEnabled: true,
        animationDelay: '0',
        contentAlignment: 'left',
        imageWidth: '500px'
      },
      settings: {
        fullWidth: false
      }
    },
    
    // Featured Products Section
    {
      type: 'featuredProducts',
      content: {
        title: 'Featured Products',
        showTitle: true,
        showSeparator: true,
        searchEnabled: false,
        maxProducts: 5,
        gridColumns: {
          mobile: 1,
          tablet: 2,
          desktop: 3,
          widescreen: 5
        },
        showProductDescription: false,
        showPricing: true,
        showViewAllButton: true,
        viewAllButtonText: 'View All Products',
        viewAllButtonLink: '/products',
        viewAllButtonColor: '#033568',
        viewAllButtonTextColor: '#ffffff',
        imageAspectRatio: '100%',
        backgroundColor: '#ffffff',
        titleColor: '#111827',
        separatorColor: '#9CA3AF',
        cardBorderEnabled: true,
        cardBorderColor: '#E5E7EB',
        cardShadowEnabled: true,
        priceColor: '#2563EB',
        hoverEffectEnabled: true,
        apiPath: '/api/products/basic',
        marginTop: '4rem',
        marginBottom: '8rem',
        gapSize: '1.5rem'
      },
      settings: {
        fullWidth: false
      }
    },
    
    // Statistics Section
    {
      type: 'statistics',
      content: {
        statistics: [
          { value: "1000+", label: "Happy Clients", delay: 0 },
          { value: "50K+", label: "Products Delivered", delay: 200 },
          { value: "98%", label: "Client Satisfaction", delay: 400 },
          { value: "24/7", label: "Customer Support", delay: 600 }
        ],
        backgroundColor: '#033568',
        statsPerRow: {
          mobile: 1,
          tablet: 2,
          desktop: 4
        },
        textColor: '#ffffff',
        statValueSize: 'text-4xl md:text-5xl',
        statLabelSize: 'text-lg',
        statLabelColor: '#d1d5db',
        backgroundOverlayEnabled: true,
        overlayFrom: 'rgba(31, 41, 55, 0.3)',
        overlayTo: 'rgba(30, 58, 138, 0.3)',
        showFloatingOrbs: true,
        orbColors: ['#FFEB3B', '#4299E1'],
        cardBackgroundColor: 'rgba(255, 255, 255, 0.05)',
        cardBorderColor: 'rgba(255, 255, 255, 0.1)',
        cardHoverEffect: true,
        showSeparatorLines: true,
        separatorColorTop: 'rgba(1,50,99,0.8)',
        separatorColorBottom: 'rgba(1,50,99,0.8)',
        paddingTop: '8rem',
        paddingBottom: '10rem',
        marginBottom: '5rem',
        animationEnabled: true,
        animationStyle: 'fade',
        shadowEnabled: true,
        borderRadius: '0.5rem',
        cardGap: '2rem',
        containerMaxWidth: 'max-w-7xl'
      },
      settings: {
        fullWidth: true
      }
    },
    // Features Section (Why Choose Bag & Box)
    {
      type: 'features',
      content: {
        title: 'Why Choose Bag & Box?',
        subtitle: 'We combine quality, innovation, and sustainability to deliver the perfect packaging solution for your brand.',
        features: [
          {
            icon: 'star',
            title: 'Premium Quality',
            description: 'All our products are crafted with premium materials for exceptional durability and presentation.'
          },
          {
            icon: 'leaf',
            title: 'Eco-Friendly',
            description: 'We prioritize sustainable materials and manufacturing processes to minimize environmental impact.'
          },
          {
            icon: 'award',
            title: 'Custom Designs',
            description: 'Our design team works with you to create unique packaging that perfectly represents your brand.'
          },
          {
            icon: 'truck',
            title: 'Fast Delivery',
            description: 'With our efficient production and shipping, your orders will arrive right when you need them.'
          }
        ],
        backgroundColor: '#f9fafb',
        titleColor: '#111827',
        subtitleColor: '#4b5563',
        featureTitleColor: '#1f2937',
        featureDescriptionColor: '#6b7280',
        iconColor: '#3b82f6',
        iconBackgroundColor: '#e0f2fe',
        borderEnabled: true,
        borderColor: '#e5e7eb',
        cardShadow: true,
        cardBackgroundColor: '#ffffff',
        cardBorderRadius: '0.75rem',
        columnsPerRow: {
          mobile: 1,
          tablet: 2,
          desktop: 4
        },
        paddingTop: '5rem',
        paddingBottom: '5rem',
        marginBottom: '2rem',
        animationEnabled: true,
        animationDelay: 100,
        showDivider: true,
        dividerColor: '#3b82f6',
        alignCenter: true,
        iconSize: 'large'
      },
      settings: {
        fullWidth: false
      }
    },

    // Testimonials Section (What Our Clients Say)
    {
      type: 'testimonials',
      content: {
        title: 'What Our Clients Say',
        subtitle: 'Hear from businesses who have transformed their packaging with us',
        testimonials: [
          {
            id: 1,
            name: 'Sarah Johnson',
            company: 'Bright Boutique',
            role: 'Owner',
            content: 'The custom shopping bags exceeded our expectations. Our customers love taking them home and they\'ve become a walking advertisement for our boutique!',
            rating: 5,
            imageUrl: '/images/testimonial1.jpg'
          },
          {
            id: 2,
            name: 'Michael Chen',
            company: 'Organic Delights',
            role: 'Marketing Director',
            content: 'We needed eco-friendly packaging that aligned with our brand values. Bag & Box delivered beautiful kraft paper bags that our customers appreciate for their sustainability.',
            rating: 5,
            imageUrl: '/images/testimonial2.jpg'
          },
          {
            id: 3,
            name: 'Robert Fernandez',
            company: 'Luxury Gifts',
            role: 'CEO',
            content: 'The premium gift boxes we ordered have elevated our entire unboxing experience. The attention to detail and quality of materials is exactly what our luxury brand needed.',
            rating: 5,
            imageUrl: '/images/testimonial3.jpg'
          }
        ],
        backgroundColor: '#ffffff',
        titleColor: '#111827',
        subtitleColor: '#4b5563',
        cardBackgroundColor: '#f9fafb',
        cardBorderColor: '#e5e7eb',
        textColor: '#1f2937',
        companyColor: '#6b7280',
        starColor: '#f59e0b',
        buttonColor: '#6b7280',
        buttonHoverColor: '#4b5563',
        showImages: true,
        showRating: true,
        showQuoteIcon: true,
        quoteIconColor: 'rgba(0, 0, 0, 0.1)',
        layout: 'grid',
        cardsPerRow: {
          mobile: 1,
          tablet: 2,
          desktop: 3
        },
        paddingTop: '4rem',
        paddingBottom: '4rem',
        marginBottom: '3rem',
        cardBorderRadius: '0.75rem',
        cardShadow: true,
        showDivider: true,
        dividerColor: '#e5e7eb',
        animationEnabled: true
      },
      settings: {
        fullWidth: false
      }
    },

    // Newsletter Section
    {
      type: 'newsletter',
      content: {
        title: 'Join Our Newsletter',
        subtitle: 'Stay updated with our latest products, promotions, and packaging tips.',
        buttonText: 'Subscribe',
        placeholderText: 'Enter your email',
        successMessage: 'Thank you for subscribing!',
        backgroundColor: '#f3f4f6',
        textColor: '#111827',
        subtitleColor: '#4b5563',
        buttonColor: '#013263',
        buttonTextColor: '#ffffff',
        inputBackgroundColor: '#ffffff',
        inputTextColor: '#1f2937',
        inputBorderColor: '#d1d5db',
        paddingTop: '4rem',
        paddingBottom: '4rem',
        marginBottom: '0',
        showPrivacyText: true,
        privacyText: 'We respect your privacy and will never share your information.',
        showDivider: true,
        dividerColor: '#3b82f6'
      },
      settings: {
        fullWidth: false
      }
    },
    // Blog Posts Section
    {
      type: 'blogPosts',
      content: {
        title: 'Latest From Our Blog',
        titleColor: '#1f2937',
        titleSize: 'text-3xl',
        titleAlignment: 'text-center',
        showTitle: true,
        subtitle: '',
        subtitleColor: '#4b5563',
        postsCount: 3,
        postsPerRow: {
          mobile: 1,
          tablet: 2,
          desktop: 3
        },
        showViewAllButton: true,
        viewAllButtonText: 'View All Posts',
        viewAllButtonLink: '/blog',
        viewAllButtonColor: '#033568',
        viewAllButtonTextColor: '#ffffff',
        cardStyle: 'shadow',
        cardBorderRadius: '0.5rem',
        cardShadowSize: 'shadow-xl',
        cardBgColor: '#ffffff',
        cardHoverEffect: true,
        showCategory: true,
        showDate: true,
        showExcerpt: true,
        showReadMore: true,
        excerptLines: 2,
        readMoreText: 'Read More',
        readMoreColor: '#2563eb',
        readMoreIcon: true,
        imageAspectRatio: '60%',
        dateFormat: 'MM/DD/YYYY',
        categoryColor: '#2563eb',
        titleFontWeight: 'font-bold',
        spaceBetweenCards: '2rem',
        marginTop: '2rem',
        marginBottom: '8rem',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        animationEnabled: true,
        animationDelay: 150,
        apiPath: '/api/blog/posts?limit=6&sort=newest&status=published',
        placeholderImage: '/images/placeholder-blog.jpg'
      },
      settings: {
        fullWidth: false
      }
    }
  ]
};

export default HomeTemplate;